var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#60C1FC;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,1.1C6,1.1,1.1,6,1.1,12S6,22.9,12,22.9S22.9,18,22.9,12S18,1.1,12,1.1z M13.1,16.4c0,0.6-0.5,1.1-1.1,1.1 s-1.1-0.5-1.1-1.1v-5.5c0-0.6,0.5-1.1,1.1-1.1s1.1,0.5,1.1,1.1V16.4z M12,8.7c-0.6,0-1.1-0.5-1.1-1.1s0.5-1.1,1.1-1.1 s1.1,0.5,1.1,1.1S12.6,8.7,12,8.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.47e70fd58c6ba74a74df48fd263326d9.svg";
export { ForwardRef as ReactComponent };